import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { leadEndpoints } from '@/lib/api/endpoints';
import { leadKeys } from '@/lib/queryKeys';

export interface AssignableTeam {
  id: string;
  name: string;
}

export interface AssignableTeamsResponse {
  data: AssignableTeam[];
}

/**
 * Active teams a routing rule may target, served under the leads permission set
 * so a lead-configurer without `users:view` (e.g. a sales manager) can still
 * populate the routing destination picker — unlike `useGroups`, which needs the
 * generic `/groups` endpoint. The server returns only active teams.
 */
export function useAssignableTeams(options?: { enabled?: boolean }) {
  return useApiQuery<AssignableTeamsResponse>({
    queryKey: leadKeys.assignableTeams(),
    queryFn: () =>
      apiGet<AssignableTeamsResponse>(operationsClient, leadEndpoints.assignableTeams()),
    enabled: options?.enabled,
    showErrorToast: false,
  });
}
